import { createFileRoute, redirect } from "@tanstack/react-router";
import { routeHead } from "@/lib/seo/route-head";

export const Route = createFileRoute("/uk/pentru-dealeri/")({
  head: () => routeHead("/uk/pentru-dealeri/"),
  beforeLoad: () => {
    throw redirect({ href: "/dealeri", statusCode: 301, replace: true });
  },
});
